import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  NoDataWrapper, NoDataText, NoDataIcon,
} from './styles';

const NoEstimateData = ({ message }) => (
  <NoDataWrapper>
    <NoDataIcon><FontAwesomeIcon icon="exclamation-circle" color="#bfbfbf" size="4x" /></NoDataIcon>
    <NoDataText>{message}</NoDataText>
  </NoDataWrapper>
);

NoEstimateData.propTypes = {
  message: PropTypes.string,
};

NoEstimateData.defaultProps = {
  message: '',
};

export default NoEstimateData;
